var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "163px",
    height: "163px",
    viewBox: "0 0 64.00 64.00",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 4.224
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6879999999999997,
    strokeMiterlimit: 10,
    x1: 36,
    y1: 34,
    x2: 41,
    y2: 39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.257,
    y: 35.065,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 120.5036 47.0858)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6879999999999997,
    strokeMiterlimit: 10,
    width: 8.485,
    height: 26.87
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6879999999999997,
    strokeMiterlimit: 10,
    points: "12,16 18,10 8,4 6,6 "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6879999999999997,
    strokeMiterlimit: 10,
    x1: 28,
    y1: 26,
    x2: 15,
    y2: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6879999999999997,
    strokeMiterlimit: 10,
    d: "M58,12.5l-8,3.75l-4-4.125l3.5-8.062l0,0 C39.5,4.062,37,9,37,14v4L3.5,52l-1.75,6l2.125,2l6.062-1.5L44,25h4C53,25,58,22.5,58,12.5L58,12.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigIcon);
export default __webpack_public_path__ + "static/media/configIcon.296627b3608dc3b54e079b21f959b133.svg";
export { ForwardRef as ReactComponent };